// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"1a2b4c81","267":"1b2fb308","300":"e046f354","472":"51ae0895","668":"77b56b8e","787":"cd3b2956"}[chunkId] + ".chunk.js";
};